import { render } from "./StatementsModal.vue?vue&type=template&id=d3afc0aa&scoped=true"
import script from "./StatementsModal.vue?vue&type=script&lang=js"
export * from "./StatementsModal.vue?vue&type=script&lang=js"

import "./StatementsModal.vue?vue&type=style&index=0&id=d3afc0aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3afc0aa"]])

export default __exports__